export const gtmEventTypes = {
  ENTER_LOCATION: 'FED-FAD-001',
  event: 'reactjs.event',
  CLICK_CTA: 'FED-FAD-008',
  CHECK_DEALERTYPE: 'FED-FAD-CHECK_DEALERTYPE',
  CLICK_ADDRESS: 'FED-FAD-009',
  CLICK_PHONE: 'FED-FAD-010',
  CLICK_WEBSITE: 'FED-FAD-011',
  SELECT_DEALER_NAME: 'FED-FAD-012',
  SELECT_DEALER_DEPARTMENT: 'FED-FAD-013',
}

export const gtmEvents = {
  [gtmEventTypes.ENTER_LOCATION]: ({location}) => ({
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: 'Find a Dealer',
    pageAction: `Find a Dealer - Entered "${location.toUpperCase()}"`,
  }),
  [gtmEventTypes.CHECK_DEALERTYPE]: ({dealerType, eventID}) => ({
    event: 'reactjs.event',
    eventID: eventID,
    pageCategory: 'Find a Dealer',
    pageAction: `Find a Dealer - Checked "${dealerType.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_CTA]: ({
                                dealerName, ctaName, departments, address,
                              }) => ({
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_CTA,
    pageCategory: 'Find a Dealer',
    pageAction: `Find a Dealer - ${dealerName} - Clicked "CTA BUTTON ${ctaName.toUpperCase()}" - ${departments.toString()} - ${address}`,
  }),
  [gtmEventTypes.CLICK_ADDRESS]: ({dealerName, departments, address}) => ({
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: 'Find a Dealer',
    pageAction: `Find a Dealer - ${dealerName} - Clicked "ADDRESS ${address.toUpperCase()}" - ${departments.toString()} - ${address}`,
  }),
  [gtmEventTypes.CLICK_PHONE]: ({
                                  dealerName, phone, departments, address,
                                }) => ({
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: 'Find a Dealer',
    pageAction: `Find a Dealer - ${dealerName} - Clicked "PHONE ${phone}" - ${departments.toString()} - ${address}`,
  }),
  [gtmEventTypes.CLICK_WEBSITE]: ({
                                    dealerName, website, departments, address,
                                  }) => ({
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: 'Find a Dealer',
    pageAction: `Find a Dealer - ${dealerName} - Clicked "WEBSITE ${website.toUpperCase()}" - ${departments.toString()} - ${address}`,
  }),
  [gtmEventTypes.SELECT_DEALER_NAME]: ({dealerName, department, address}) => ({
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: 'Find a Dealer',
    pageAction: `Find a Dealer - Selected "${dealerName}" - ${department.toUpperCase()} - ${address}`,
  }),
  [gtmEventTypes.SELECT_DEALER_DEPARTMENT]: ({dealerName, department, address}) => ({
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_DEPARTMENT,
    pageCategory: 'Find a Dealer',
    pageAction: `Find a Dealer - ${dealerName} - Clicked "DEPARTMENT MENU - ${department.toUpperCase()}" - ${address}`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/map-search-duck.js